// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class DigitalPaymentV1ClientGeneratedReturnDetails {
    'returnAmount'?: number | null;
    'returnDate'?: Moment | null;
    'returnReasonCode'?: string | null;
    'returnReasonDescription'?: string | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof DigitalPaymentV1ClientGeneratedReturnDetails>> = [
        {
            "name":     "returnAmount",
            "baseName": "returnAmount",
            "type":     "number"
        },
        {
            "name":     "returnDate",
            "baseName": "returnDate",
            "type":     "Date"
        },
        {
            "name":     "returnReasonCode",
            "baseName": "returnReasonCode",
            "type":     "string"
        },
        {
            "name":     "returnReasonDescription",
            "baseName": "returnReasonDescription",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return DigitalPaymentV1ClientGeneratedReturnDetails.attributeTypeMap;
    }
}
